import paymentService from "../../assets/img/paymentService.png";
import tradefinanceImg from "../../assets/img/Tradefinance.png";
import insuranceImg from "../../assets/img/insuranceService.png";
import qualityAssuranceImg from "../../assets/img/qualityAssurance.png";
import freightServiceImg from "../../assets/img/freightService.png";
// import fregihtOne from "../assets/img/frieghtServicesImg.png";
// import frieghtTwo from "../assets/img/frieghtTwo.png";

export default function EToESolutionSection() {
  return (
    <section className="text-center mt-40 mb-20 space-y-10">
      <div className="px-2 lg:p-0">
        <h2 className="font-bold text-[#1A1D21] text-4xl mb-2">
          End-to-end solution geared for global trade
        </h2>

        <p className="leading-6 text-[#42474D] ">
          Whether you are a large scale business looking to optimize your
          cross-border trade operations or an SMB looking <br /> to venture into
          the global export-import markets, Taram’s one-stop platform can
          fulfill your needs with a focus <br /> on saving time and money as you
          scale your operations.
        </p>
      </div>

      <div className="container mx-auto p-4 lg:p-20 grid md:grid-cols-2 lg:grid-cols-3 gap-5 text-white">
        <div className="flex flex-col justify-between items-center bg-gradient-to-br from-[#000000] to-[#9E9E9E] shadow-md rounded-lg overflow-hidden h-[400px] p-8 pb-4">
          <div className="text-center">
            <div className="flex justify-center gap-4 mb-2">
              <svg
                width={37}
                height={36}
                viewBox="0 0 37 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <path fill="url(#pattern0_3125_5284)" d="M0 0H37V36H0z" />
                <defs>
                  <pattern
                    id="pattern0_3125_5284"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                  >
                    <use
                      xlinkHref="#image0_3125_5284"
                      transform="matrix(.01 0 0 .01028 0 -.014)"
                    />
                  </pattern>
                  <image
                    id="image0_3125_5284"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABSNJREFUeAHtnW3IFUUUx7Uss1crsYxeCf2cbwRGRkFBUZBgUJQVGBUYFRUJZZJUoFgUFFT0Sn4r+mRQURBhGIphZYhRVJhYYWlZmVr0aw7N9dnnvj3n3ruzO3fmDDw8e2fPzpzz+8/M3bu7MztunCUjYASMgBEwAkbACBgBI2AEjIARMAJGwAgYASNgBCohAMwF7vZ/cyqp1CppJQAcC7xJa3oDOKb1CMsJSgB4uVWLQzkvBa3cCh9NAJgF/HsIf/uNuaOPsk/BCABvtddgVO7aYA5YwSMEnBhzFL2jocz5I0faVhACwDsN2or/bwdxwgr9nwAwTyFCs8mFxi8QAeD9ZtqKz+8FcifvYoELFPA7mVyUN70A0QMfdKKtyF8XwKV8iwQuUUAfy+TifAmWHDnw4Vi0Ffs/KtmtPIsDLlPA1ppcmifFEqMG1mlpK+zWl+hafkUBVygg92pyeX4kS4oY2NArbYX9JmB8SS7mUwxwlQJuvyZX5kOyhEilBbvhamO/tBXHfWK9pAehgAUKqIOaXN2DS/ma+t7x6aC0FcdvAQ7Ll7QycuAaBcyyTBYq3crTTFqsG64+K4u2opwvrJd0aWvAdQqIZZtc28WlfHcBhwNby6atKO9LYEK+5DtEDixSwAtlckMHt/LM9r1jWyjainK/sl5SaHvAzQpooU1uKriU7yZwBPB1aNqK8r8FjsxXCR85cIsCVlUmi7MWxPeOb6qirajnu6x7CXC7AlLVJrdl2UukJQIybseWtgMTsxMFuCM2JQr+LMlKEOAo4PsCgNg2dwKTshEFuCs2Bdr4c2cWgvjesaMNgNiyfgCOTl4U4N7YyHfx556kBZHJmO5U98cuAGLbtUsmlyYrCrA0NuIKf+5PUhA/jfknBYDYTH4GjktOFODB2Ej34M8DSQkCHA/80gOA2Ez3AJOTEcXNml0eG+E+/HkoCUGAE4DdfQCI7ZBfgROHXhT34NuK2MgO4M/DQy2IjLvuMomMv6mk34CThlYUdwPqsVSUKMTx6FAKApwM7C0Eksrm78DUoRPFXb5elYoCbeJYOVSCAFPcRURpSammP4BThkYUd6nhiVSVKMT1+FAIApwK/FlwPNXNv4DTohfFneo+laoCbeJ6MmpBgGnAvjaOp5olveT0aEVxX+bPpEq+S1xPRykIcAawv4vjqe46AJwdnSjuy/y5VIkr4no2KkGAswBpKbmmg8A50YjivthezFWJQtwvRCGIjJ+Z946GJtJLzq1dFCfIqw2P7D+v1CoIMN09vPB3zUJsdnMUH/F/sl1nEhbTaxPFddE1NUQvJw/vAkvcgvxnNgcveX6f2NRxorGm2adKPsv95QoDlidWXgdulHv02gDl2Vy/zNPzgDyrW0WS75Lq7yoCCwNHJxP6VwPzZdq0VoROdn7qtZQlZUrZIdOCTn4Ey/ettcyg/vGrj94HzAjmuC9Y6gCkLlnxVOouM10f2v+W8v2rhgYNQi7TrwVulcv2LZVUlCFDjF+F6DX36iR53GfQdF5Fro9U41fu+bwPz2Wmq1yElOVfo5sX7uc+im/io/jaa5IzvXrWdPTv8hjrQQZ5E44s17cMqL7ljLShvrbEZ++7xDDWW33kMaHZfVVU1kHATODjpmYk90QaQ9G0suqquxx/v0eGV4mt+b7P+qganP+RKOvszs5hKpg/pZZYJeb6fgzW3UqtfiNgBIyAETACRsAIGAEjYASMgBEwAkbACBgBI2AEjIARMAJGwAj0SOA/IjOK0zy0n3QAAAAASUVORK5CYII="
                  />
                </defs>
              </svg>{" "}
              <h3 className="text-lg font-bold flex items-center">
                Freight Services
              </h3>
            </div>

            <p className="text-sm">Book Freight Services- Sea, Air, Land</p>
          </div>

          <div>
            <img src={freightServiceImg} alt="paymentService" />
          </div>
        </div>
        <div className="flex flex-col justify-between bg-gradient-to-b from-[#155DE9] to-[#9DB4E1] shadow-md rounded-lg overflow-hidden h-[400px] p-8 pb-0">
          <div className="text-center">
            <div className="flex justify-center gap-4 mb-2">
              <svg
                width={33}
                height={37}
                viewBox="0 0 33 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <rect width={33} height={37} fill="url(#pattern0_3125_5290)" />
                <defs>
                  <pattern
                    id="pattern0_3125_5290"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                  >
                    <use
                      xlinkHref="#image0_3125_5290"
                      transform="matrix(0.0112121 0 0 0.01 -0.0606061 0)"
                    />
                  </pattern>
                  <image
                    id="image0_3125_5290"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABRxJREFUeAHtnUnIHEUYhqMmXgS3YKK5KQFFxBjUoAdBEM9qRMQV1IMevEgIiKCHgOACakIQJYoSEDyLy03FGDx4FRFcwLiBBzcUdx+7/Gugpmequqq6un+r5+3LdFd99X3Vzzs9X3d1d82GDVpEQAREQAREQAREQAREoAgB4GxgD3BlEYdykk8AOA/4jrXlH+D6fG9q2YsAcArwkRVj9vFcL6dqnEcAOB54ZaaC87knz6Na9SLQCLLPEcFdPb+XYzVOJwBcA5h80V6OpXtTi14EgHOBH9pK2O1nejlX4zQCwMnAhx4xTPG1aR5lnU3AJvFXA2L8Yc66sgOoYRoB4OGAGKbqzTSPss4mYH6KPEnc1WhvdgA1jCdgr8R/dMl71i+I9yrLLALAacDHHgHc4i+A47KCqFEcAZvEX3OpB9YPxXmVVTYB4JGAAO2q3dmB1LCbALA7IonPRPlTp7vdTLMtgAuBn2e0Iz7fzg6mhmECwOnAJxEiuCb3h72qNouATeKvu6Qj13dkBVSjMAHg8UgBXLOvdbob5ppVa267JiRxV5DnswKqkZ8AsCMxibuC3OD3rJpkAjaJf+oSTlj/y7RPDqoGywkAJwBvJAjQNj2y3LNKswg0N5ueaBNO3H4gK7AaLRJoBgxvSYS/zHznomeVJBMALgJ+WUY4oewbne4mo19sAGwGPksA7zN9cdG7SpIIABvNbVYf4cTyG5OCy3iRQHOzaX8idJ+5Od3dvBhBJdEEmgHDW310M8qPRgeW4SIBYGeBJO7q9uBiFJVEESiYxF1BLokKLqN5As1zVJuAt1ySBda/NcP085G0FUUAOFhAgLaLw1HBZTRPALitTbLQ9s3zkbTVSQDYBfxaSICh3fwOHDYDnZ07VqMBsBUwD63VtkzvqXmbxI/UpoTt73U1HgDBPgNPVyqG+RJtDO5cbZXNgOHtlYphHpLYVhvvYH+By4DfKhTEnHjsCu5cbZXAmcCXFYphunxXbbyD/bVJ/J1KxTgY3LkaK4FnKxXjKHBijcy9fQburlSMSSbxy5XEvd/VcSuUxMflHYxmk/h7lf5UTTKJ31SpGOZMcFPw21ZjJVCjIGagc2uNvDv7bH+yXgLMkHUNy/SuxDtVKmQAHBpA4WldiRdi3enGvspmHg0tuRzoDCyD5QTs4GRJMaZ3Jb4c3TClTW7qmuUnRazpXYkPg93vFfgghXjAVkncjzmupnnA4JwA4NQqJfE47H4r4L5U6h57JXE/5viaQq8nvDu54fR4hOUsgVMBM09in+Wr5r7MWeV6tcKeCrxnaJL4pSuMsOyuN1P3vdzn0ADuLNujFfZmx8W+7yHI/hXGV37Xgat7iKEkXlqSZkqMA5mCHGuekNxSuj8r7y/z1Wgl8SG+OXbigJwDREl8IEEeylBDSXwIMYxP4P1EQZTEBxRjW+LMcUriQ4lhj457Eo4OJfEhxbCCxE4dbnRTEh9SkGbW0ZMSXgZ9asi+yPdaMjfTh8cs5hWzaT2d/n/8BgAvRKihJD6GeHbCSzMtRmhREh9DDBMDuCKkhK1TEh9RkMc6BFESH0sMe4S0/0DY1UdJfGQxtrv0W+ufazh9TDXW8sfelgizTSXxkbX4Lxzge3X6jvXoz0rHtFP8mf+Iai9PrjSY9dp5zxwoZtq/aU32sl6AU+MCj7YODZPEz0j1I/tCBICrgL+tKD8BFxdyLTe5BMzThcC9wPZcH2onAiIgAiIgAiIgAiIgAvME/gUsYOPrVICSTQAAAABJRU5ErkJggg=="
                  />
                </defs>
              </svg>

              <h3 className="text-lg font-bold flex items-center">
                Payment Services
              </h3>
            </div>

            <p className="text-sm">
              Perform instant settlement, Letter of Credit, <br /> Smart Escrow,
              and Forex
            </p>
          </div>

          <div className="flex justify-center items-baseline">
            <img src={paymentService} alt="paymentService" />
          </div>
        </div>

        <div className="flex flex-col justify-between bg-gradient-to-br from-[#000000] to-[#9E9E9E] shadow-md rounded-lg overflow-hidden h-[400px] p-8 pb-4">
          <div className="text-center">
            <div className="flex justify-center gap-4 mb-2">
              <svg
                width={43}
                height={23}
                viewBox="0 0 43 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <rect width={43} height={23} fill="url(#pattern0_3125_5296)" />
                <defs>
                  <pattern
                    id="pattern0_3125_5296"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                  >
                    <use
                      xlinkHref="#image0_3125_5296"
                      transform="matrix(0.01 0 0 0.0186957 0 -0.434783)"
                    />
                  </pattern>
                  <image
                    id="image0_3125_5296"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAatJREFUeAHt3bENg0AUBUEKoQM3QCNUSZEfJw6JbhPkQSKy9IJZR+gE2+YiQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECPy5wMwcM3O6E4Nj+e80M9e4KoFLkIqy2RGkccxWBMkomyFBGsdsRZCMshkSpHHMVgTJKJshQRrHbEWQjLIZEqRxzFYEySiboSTI/n2e9XEnBvvysywDBAgQIECAAAECBAgQIECAAAECjwIOyiUH5H4HDR2Uax7SZivJ014nF7MeI0hnmSwJkjB2I4J0lsmSIAljNyJIZ5ksCZIwdiOCdJbJkiAJYzciSGeZLAmSMHYjgnSWyZIgCWM3IkhnmSwJkjB2I4J0lsmSIAljNyJIZ5ksCZIwdiOCdJbJkiAJYzciSGeZLAmSMHYjgnSWyZIgCWM3IkhnmSwJkjB2I4J0lsmSIAljNyJIZ5ksCZIwdiOCdJbJkiAJYzciSGeZLAmSMHYjgnSWyZIgCWM3IkhnmSwJkjB2I4J0lslSEsQnj7pPPq2/yeHxnRt+IECAAAECBAgQIECAAAECBAgQIECAAAECBAi8Q+AGclV4/K4YSGcAAAAASUVORK5CYII="
                  />
                </defs>
              </svg>

              <h3 className="text-lg font-bold flex items-center">
                Trade Finance
              </h3>
            </div>

            <p className="text-sm">
              Easy access to revolving line of credit via Invoice Factoring
              solutions.
            </p>
          </div>
          <div className="flex justify-center items-baseline">
            <img src={tradefinanceImg} alt="paymentService" />
          </div>
        </div>

        <div className="flex flex-col justify-between bg-gradient-to-b from-[#155DE9] to-[#9DB4E1] shadow-md rounded-lg overflow-hidden h-[400px] p-8 pb-4">
          <div className="text-center">
            <div className="flex justify-center gap-4 mb-2">
              <svg
                width={48}
                height={48}
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <path fill="url(#pattern0_3125_5299)" d="M0 0H48V48H0z" />
                <defs>
                  <pattern
                    id="pattern0_3125_5299"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                  >
                    <use xlinkHref="#image0_3125_5299" transform="scale(.01)" />
                  </pattern>
                  <image
                    id="image0_3125_5299"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,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"
                  />
                </defs>
              </svg>
              <h3 className="text-lg font-bold flex items-center">
                Quality Assurance
              </h3>
            </div>

            <p className="text-sm">
              Perform Vendor Due Diligence, Factory Audit, Loading Inspection,
              and Quality Testing
            </p>
          </div>
          <div className="flex justify-center items-baseline">
            <img src={qualityAssuranceImg} alt="paymentService" />
          </div>
        </div>

        <div className="flex flex-col justify-between items-center bg-gradient-to-br from-[#000000] to-[#9E9E9E] shadow-md rounded-lg overflow-hidden h-[400px] p-8">
          <div className="text-center">
            <div className="flex justify-center gap-4 mb-2">
              <svg
                width={27}
                height={29}
                viewBox="0 0 27 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <path fill="url(#pattern0_3125_5287)" d="M0 0H27V29H0z" />
                <defs>
                  <pattern
                    id="pattern0_3125_5287"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                  >
                    <use
                      xlinkHref="#image0_3125_5287"
                      transform="matrix(.01074 0 0 .01 -.037 0)"
                    />
                  </pattern>
                  <image
                    id="image0_3125_5287"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,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"
                  />
                </defs>
              </svg>
              <h3 className="text-lg font-bold flex items-center">Insurance</h3>
            </div>

            <p className="text-sm">Book freight & goods insurance</p>
          </div>

          <div>
            <img src={insuranceImg} alt="paymentService" />
          </div>
        </div>

        <div className="flex flex-col justify-between items-center bg-gradient-to-b from-[#155DE9] to-[#9DB4E1] shadow-md rounded-lg overflow-hidden h-[400px] p-8 pb-0">
          <div className="text-center">
            <div className="flex justify-center gap-4 mb-2">
              <svg
                width={47}
                height={47}
                viewBox="0 0 47 47"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <path fill="url(#pattern0_3125_5308)" d="M0 0H47V47H0z" />
                <defs>
                  <pattern
                    id="pattern0_3125_5308"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                  >
                    <use xlinkHref="#image0_3125_5308" transform="scale(.01)" />
                  </pattern>
                  <image
                    id="image0_3125_5308"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA8lJREFUeAHtnUFuE0EQRXMNBBwICbgHiKxZkiVHAIkVdwgcJRK3CLAj6MMItzT+iT3T/Xuq2vhnMy6P63fVe4mThREXF/4yARMwARMwARMwARMwgRQCAK4AvE853IfuE9jJwO7LUvbxxFYkw1Ji8e+fdkCGpexjiqkWZFhKjIZ/p6yUYSkRUiplWMqWUhplWMoWUkQZltJTSicZltJDSmcZlqJI2UiGpbRI2ViGpdRICZJhKWukBMuwlGNSkmRYykNSkmVYylzKIDIsZZIymIzzljKojPOWMn/rWnpcSLVel/J9v5JAq4jSV3mcX75EoIBtvS7l+34lgVYRpa/yOL98iUAB23pdyvf9SgKtIkpf5XG5LwfwFMAbAF8B3AD4WRbJujIRdQ7OG7IG8BjARwC/1IV79zMwNZ/zhqsBvATwXV10q34Gpp7DeUPVAC4B/FaX3LKfgalncd4wNYBnAO7UBbfuZ2DqeZw3RL37nTHs29QcOgOb32t5zHlD1AA+tSyT0cPA1Bk4L73e/Wk7/FtVAc/AyvOtV85Lr3e/yFv3Ce9jYOoAnJdeA/iiLhXZz8DUszkvvQbwTV0qsp+BqWdzXnoN4Ie6VGQ/A1PP5rz0Wl0oup+BqedzXnqtLhTdz8DU8zkvvVYXiu5nYOr5nJdeqwtF9zMw9XzOS69PfaFTn//eN8CpL3Tq81sIGbwHJPsJmq+69PydCVQboAYeh24PX/L86bVKjBdQ86L7ef70WgXAC6h50f08f3qtAuAF1Lzofp4/vVYB8AJqXnD/Lc+fXqsAeAE1L7j/hudPr1UAvICaF9x/zfOn1yoAXkDNC+5/xfOn1yoAXkDNC+yfPib7hOdPr1UAvICaF9j/gWcfolYB8BJqXlD/7d8Pkz/i2YeoVQC8hJoX0D99dvkFzz1MrQLgRdS8jfsnGZc881C1CoCXUfM27J/epp7zvMPVKgBeSM3boH/6qfg87O+M3gB753UQMn3ObPrnd9cAXg/5py1Dm9cqgHmWH3cgYCEdIPaMsJCeNDtkWUgHiD0jLKQnzQ5ZFtIB4rEIAG9VyBv2vzs2+397b1Ap5ymjfJcNJuW8ZQwmxTKKkOma/JNiGXMZ5XGSFMsoAh66BkuxjIck8HNBUiyDwR+rN5ZiGcfgH7q3kRTLOAR8zfOdpVjGGuhLr+kkxTKWQNfcF6VYRg3sta9tlGIZawG3vK5SimW0QK7tWSnFMmrBKq9fkGIZCtzW3gNSLKMVaI8+kmIZPaCqGbv/D+pKzXG/CZiACZiACZiACZiACbQR+AOefgJi4NQjMAAAAABJRU5ErkJggg=="
                  />
                </defs>
              </svg>
              <h3 className="text-lg font-bold flex items-center">
                Document Exchange
              </h3>
            </div>

            <p className="text-sm">Digital Document and title transfer</p>
          </div>

          <div>
            <img src={paymentService} alt="paymentService" />
          </div>
        </div>
      </div>
    </section>
  );
}
